import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { makeStyles, Theme } from '@material-ui/core/styles';
import PageContainer from '../../@layout/PageContainer';
import { ModuleProps } from '../../../types';
import Tile from '../../@common/Tile';
import HeaderBar from '../HeaderBar';
import useStore from 'store';
import Config from 'config';

import ClassIcon from '../../../assets/admin_console-classes.png';
import HelpIcon from '../../../assets/admin_console-help.png';
import RosterIcon from '../../../assets/admin_console-roster.png';
import OrganizationIcon from '../../../assets/admin_console-orgs.png';
import ProductIcon from '../../../assets/admin_console-products.png';
import UserIcon from '../../../assets/admin_console-users.png';

const { privilegesGroups } = Config;

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      display: 'grid',
      gridGap: 24,
      gridTemplateColumns: `repeat(auto-fit, minmax(327px, 1fr))`,
      gridAutoFlow: 'dense',
      padding: `${theme.spacing(3)}px ${theme.spacing(5)}px`
    }
  };
});

const getAdminItems = (): Array<{
  icon: string;
  title: string;
  description: string;
  route: string;
  privileges: Array<string>;
  path?: string;
}> => [
  {
    icon: UserIcon,
    title: 'User Management',
    description: 'View and manage admin and educator access.',
    route: 'user-management',
    privileges: privilegesGroups.moduleLevel.adminConsole.userManagement
  },
  {
    icon: ProductIcon,
    title: 'Products & Licenses',
    description: 'Manage Learning Without Tears digital product licenses.',
    route: 'products-licenses',
    privileges: privilegesGroups.moduleLevel.adminConsole.productsLicenses
  },
  {
    icon: ClassIcon,
    title: 'Classes & Students',
    description: 'View and manage classes and students.',
    route: 'classes-students',
    privileges: privilegesGroups.moduleLevel.adminConsole.classesStudents
  },
  {
    icon: OrganizationIcon,
    title: 'Organizations',
    description: 'View and manage your district, schools, and institutions.',
    route: 'organizations',
    privileges: privilegesGroups.moduleLevel.adminConsole.organizations
  },
  {
    icon: RosterIcon,
    title: 'Roster Management',
    description: 'View data integration options and instructions.',
    route: 'roster-management',
    privileges: privilegesGroups.moduleLevel.adminConsole.rosterManagement
  },
  {
    icon: HelpIcon,
    title: 'Help for Administrators',
    description: 'Access and search our knowledge base and resources.',
    route: '1', // NOTE: this is a hard-coded Support Category pk
    path: 'support',
    privileges: privilegesGroups.moduleLevel.adminConsole.administratorHelp
  }
];

const AdminConsole: React.FC<ModuleProps> = props => {
  const history = useHistory();
  const match = useRouteMatch();
  const classes = useStyles();
  const [{ userPrivilegesCache }] = useStore();
  const adminItems = getAdminItems().filter(x => userPrivilegesCache.isPrivileged(x.privileges));

  const handleTileClick = (route: string, path?: string) => (): void => {
    history.push(`${path || match.path}/${route}`);
  };

  return (
    <PageContainer>
      <HeaderBar {...props} />
      <div className={classes.container}>
        {adminItems.map(({ route, path, ...item }, key) => (
          <Tile key={`admin_tile_${key}`} handleClick={handleTileClick(route, path)} {...item} />
        ))}
      </div>
    </PageContainer>
  );
};

export default AdminConsole;
